import React, { useEffect, useState } from 'react'
import { viewItemDetailsProp } from '../../types/item.mster.type'
import { Modal } from 'react-bootstrap'
import DataGrid, { Column, MasterDetail, Scrolling } from 'devextreme-react/cjs/data-grid'
import { getItemMasterDetailsByHeaderId } from './services'
import notistack from 'pages/Core/Notistack'

const ItemMasterViewDetails: React.FC<viewItemDetailsProp> = ({ isOpen, reloadDataSource, onClose, selectedId }) => {
    const [data, setData] = useState<any>([])
    const getItemDetailsById = async (id: number) => {
        try {
            const response = await getItemMasterDetailsByHeaderId(id);
            if (Array.isArray(response.data)) {
                setData(response.data);
            }
        } catch (error: any) {
            notistack.error(error || 'Failed to fetch item details.');
        }
    }

    useEffect(() => {
        if (isOpen && selectedId) {
            getItemDetailsById(selectedId);
        }
    }, [isOpen, selectedId]);

    return (
        <>
            <Modal
                show={isOpen}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog-centered"
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Product Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    <DataGrid
                        dataSource={data}
                        showRowLines={true}
                        keyExpr="id"
                        showBorders={true}
                    >
                        <Scrolling
                            mode="standard"
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />

                        <Column dataField="materialType" caption="Material Type" />
                        <Column dataField="metalColor" caption="Metal Color" />
                        <Column dataField="karat" caption="Karat" />
                        <Column dataField="makingType" caption="Making Type" />
                        <Column dataField="stoneType" caption="Stone Type" />
                        <Column dataField="size" caption="Size" dataType="number" format="#0.00" />
                        <Column dataField="weight" caption="Gross Wt" dataType="number" format="#0.000" />
                        <Column dataField="netWeight" caption="Net Wt" dataType="number" format="#0.000" />

                        <Column
                            dataField="diamondQty"
                            caption="Diamond Qty"
                            dataType="number"
                            format="#0.00"
                        />

                        <Column
                            dataField="collorStoneWeight"
                            caption="Color Stone Wt"
                            dataType="number"
                            format="#0.000"
                        />

                        <MasterDetail
                            enabled={true}
                            component={({ data }) => {
                                return (
                                    <div style={{ background: "#f8f9fa" }}>
                                        <h6>Raw Materials</h6>

                                        <DataGrid
                                            dataSource={data?.data?.itemMasterRawMaterials ?? []}
                                            keyExpr="id"
                                            showBorders={true}
                                            columnAutoWidth={true}
                                        >
                                            <Column dataField="mf" caption="MF" width={100} cssClass='text-center' />
                                            <Column dataField="rowType" caption="Raw Type" width={100} cssClass='text-center' />
                                            <Column dataField="weight" caption="Gross Weight" format="#0.000" width={150} cssClass='text-center' />
                                            <Column
                                                dataField="karat"
                                                caption="Karat"
                                                width={100}
                                                cssClass='text-center'
                                            />
                                            <Column dataField="qty" caption="Qty" width={100} />
                                            <Column dataField="stoneWeight" caption="Stone Wt" width={100} cssClass='text-center' format="#0.000" />
                                            <Column dataField="diamondWT" caption="Dia Weight" width={100} cssClass='text-center' format="#0.000" />
                                            <Column dataField="diamondSize" caption="Dia Size" width={100} cssClass='text-center' format="#0.00" />
                                            <Scrolling
                                                mode="standard"
                                                useNative={true}
                                                scrollByContent={true}
                                                scrollByThumb={true}
                                            />
                                        </DataGrid>
                                    </div>
                                );
                            }}
                        />
                    </DataGrid>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ItemMasterViewDetails
